import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export function animation() {
  // フッター TOPスクロールボタン
  // document.getElementById("js-scrollTop").addEventListener("click", () => {
  //   gsap.to(window, {
  //     duration: 1,
  //     scrollTo: {
  //       y: 0,
  //       autoKill: false,
  //     },
  //   });
  // });

  // アニメーションを初期化する関数
  const initAllAnimations = () => {
    // フェードインアニメーション
    // const fadeInElements = document.querySelectorAll(".js-fade-in");
    // fadeInElements.forEach((element) => {
    //   gsap.fromTo(
    //     element,
    //     {
    //       opacity: 0,
    //       // y: 30,
    //     },
    //     {
    //       opacity: 1,
    //       y: 0,
    //       duration: 2,
    //       ease: "power4.out",
    //       immediateRender: false, // 初期状態を確実に適用
    //       scrollTrigger: {
    //         trigger: element, // トリガーとなる要素を指定
    //         start: "top 85%", // スクロール開始位置を指定
    //         once: true, // 一度だけ発動
    //         //markers: true,
    //       },
    //     }
    //   );
    // });

    const fadeInLeftElements = document.querySelectorAll(".js-fade-in-left");
    fadeInLeftElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          x: -5,
        },
        {
          opacity: 1,
          x: 0,
          duration: 0.5,
          ease: "power1.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 80%", // スクロール開始位置を指定
            //markers: true,
          },
        }
      );
    });

    const fadeInRightElements = document.querySelectorAll(".js-fade-in-right");
    fadeInRightElements.forEach((element) => {
      gsap.fromTo(
        element,
        {
          opacity: 0,
          x: 5,
        },
        {
          opacity: 1,
          x: 0,
          duration: 0.5,
          ease: "power1.out",
          scrollTrigger: {
            trigger: element, // トリガーとなる要素を指定
            start: "top 70%", // スクロール開始位置を指定
            //markers: true,
          },
        }
      );
    });
  };

  // アニメーションを初期化
  initAllAnimations();

  // 外部スクリプトの読み込み完了後、定期的にScrollTriggerを再計算
  window.addEventListener("load", () => {
    // 初回の再計算
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 1000);

    // さらに待って再計算（外部スクリプトがDOMを変更する時間を確保）
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 2000);

    // スクロール時にも再計算（念のため）
    let scrollTimeout;
    window.addEventListener("scroll", () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    }, { passive: true });
  });


  $(()=> {
    $('.btn').modalVideo({channel: 'youtube'});
 });
 
}





